import { API_IP } from "../global_variables";

function authHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };
}

// GET /api/payment-options/:bookingId
// Returns: { baseAmount, etransfer:{amount,fee,note}, stripe:{amount,fee,note,breakdown} }
export async function fetchPaymentOptions(bookingId) {
  const res = await fetch(`${API_IP}/api/payment-options/${bookingId}`, {
    method: "GET",
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error("Could not load payment options");
  return res.json();
}
